'use client'

import { usePathname, useSearchParams } from 'next/navigation'

export function useFullPath() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    url.pathname = pathname
    url.search = searchParams.toString()
    return url.toString()
  }

  return `${pathname}?${searchParams.toString()}`
}
